export const ROLES = {
  ADMIN: "ROLE_ADMIN",
  PASTEUR: "ROLE_PASTEUR",
  TRESORERIE: "ROLE_TRESORERIE",
};

export const hasAnyAuthority = (
  userAuthorities: string[] | undefined,
  allowedRoles: string[],
): boolean => {
  if (!userAuthorities) return false;
  // Vérifie si au moins un des rôles de l'utilisateur est inclus dans les rôles autorisés
  return userAuthorities.some((auth) => allowedRoles.includes(auth));
};
